function getBreakpointValue(breakpoint) {
	const initialRetrievedValue = getComputedStyle(document.documentElement).getPropertyValue(`--bs-breakpoint-${breakpoint}`).trim();
	let finalValuePX = 1200; // using 1200 as a fallback

	if(initialRetrievedValue.endsWith('rem')) {
		finalValuePX = parseInt(initialRetrievedValue) * 16;
	} else if(initialRetrievedValue.endsWith('px')) {
		finalValuePX = parseInt(initialRetrievedValue);
	}

	return finalValuePX;
}

function getNavBreakpointValue() {
	const topNav = document.getElementById('top-nav');
	if(topNav && topNav.getAttribute('bs-nav-breakpoint')) {
		return getBreakpointValue(topNav.getAttribute('bs-nav-breakpoint'));
	}
}

export { getBreakpointValue, getNavBreakpointValue }